import { polygon, centroid, booleanPointInPolygon } from "@turf/turf";
import relatedpointer from "@/utils/relatedpointer";

/**
 * @description 获取一个图形的平均质心
 * @param rings {ring[]} 至少三个顶点
 * @param rings
 * @returns {Position}
 */
export function getPolygonCentroid(rings) {
  const poly = polygon(rings);
  let point = centroid(poly);
  let isInPolyon = booleanPointInPolygon(point, poly);
  if (!isInPolyon) {
    var relatedPinter = relatedpointer.indexfn(rings, 21);
    return relatedPinter;
  }
  return point.geometry.coordinates;
}

/**
 * @description 获取一个数组的维度，数组最好是一个标准的多维结构，否则只会返回数组的第一项数组的维度
 * @param array
 * @param length default 1
 * @returns {number}
 */
export const arrayDimensionalLength = (array, length = 1) => {
  const nextArray = array.find((item) => item instanceof Array);
  if (nextArray) {
    length = arrayDimensionalLength(nextArray, length + 1);
  }
  return length;
};
